export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    CHARGE_CONFIGS_ALL: function CHARGE_CONFIGS_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/charge-configs/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    CHARGE_CONFIGS_CREATE: function CHARGE_CONFIGS_CREATE(data) {
      return request({
        url: '/api/charge-configs/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    CHARGE_CONFIGS_DETAIL: function CHARGE_CONFIGS_DETAIL(id) {
      return request({
        url: '/api/charge-configs/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    CHARGE_CONFIGS_UPDATE: function CHARGE_CONFIGS_UPDATE(data) {
      return request({
        url: '/api/charge-configs/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    CHARGE_CONFIGS_DELETE: function CHARGE_CONFIGS_DELETE(id) {
      return request({
        url: '/api/charge-configs/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});